/**
 * @ComponentFor CategoryTreeViewModel
 */
import React from 'react';
import { styled } from '@glitz/react';
import CategoryItemViewModel from './CategoryItemViewModel.type';
import Link from 'Shared/Link';
import { AspectRatioOuter, HoverAspectRatioInner } from 'Shared/SharedComponents/atoms/AspectRatio';
import { setImageBackground, Preset } from 'Shared/image-background';
import SwiperList from 'Shared/SwiperList';
import * as style from 'Shared/Style';

type PropType = {
  categories: CategoryItemViewModel[];
  isCompact: boolean;
};

const SwiperWrap = styled.div({
  width: '100%'
})

const CategoryHeading = styled.h2({
  position: 'absolute',
  bottom: 0,
  width: '100%',
  paddingBottom: '12px',
  margin: { top: 0, bottom: 0 },
  textAlign: 'center',
  fontSize: '14px',
  textTransform: 'uppercase',
})

const CategoryLink = styled(Link, {
  textDecoration: 'none', color: 'black'
})

const CategoryContentWrap = styled(AspectRatioOuter, {
  paddingTop: '100%',
  borderRadius: '8px',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
})

const CategoryContentInner = styled(HoverAspectRatioInner, {
  height: '100%',
  ['@media ' + style.mediaUpToLarge]: {
    border: { xy: { style: 'none' } },
    ':hover': {
      border: { xy: { style: 'none' } },
    }
  },
})

const Categories = (props: PropType) => {
  const { categories, isCompact } = props;
  const slidesPerView = isCompact ? 2.5 : 5.5;
  const spaceBetween = isCompact ? 12 : 16;
  const showNav = slidesPerView < categories.length;

  return (
    <SwiperWrap>
      <SwiperList isCompact={isCompact} slidesPerView={slidesPerView} spaceBetween={spaceBetween} showNav={showNav} navIndentLeft={true} cssMode={true} freeMode={true} slidesPerGroup={isCompact ? 1 : 2}>
        {categories.map((category, index) => (
          <div key={index} className="swiper-slide">
            <CategoryLink to={category.url}>
              <CategoryContentWrap
                css={{
                  backgroundImage: setImageBackground(category.image?.url as string, Preset.SquareListItem),
                }}
              >
                <CategoryContentInner>
                  <CategoryHeading>
                    {category.displayName}
                  </CategoryHeading>
                </CategoryContentInner>
              </CategoryContentWrap>
            </CategoryLink>
          </div>
        ))}
      </SwiperList>
    </SwiperWrap>
  );
};

export default Categories;
